export interface SmallCardProps {
  descriptionId?: string;
  description: string | React.ReactNode;
  imageSrc?: string;
  href?: string;
  countRow?: number;
  backgroundSrc?: string;
  enumeration?: boolean;
  index?: number;
  type?: 'enumeration' | 'blurred';
  buttonContent?: string;
  buttonLink?: string;
  subDescription?: string;
  subDescriptionId?: string;
  smoothScroll?: boolean;
  className?: string;
  alt?: string;
  customClassNames?: {
    content?: string;
    img?: string;
    subDescription?: string;
  };
}

export enum SmallCardType {
  ENUMERATION = 'enumeration',
  BLURRED = 'blurred',
}
